import type { RiskAssessmentViewModel } from '@trinnvis/dabih-api-client';
import { riskLevelFromRisk } from '../../../models/risk';
import { calculateUpdateStatus } from '../../../models/resolvers/calculate-update-status';
import { LocalDate } from '../../../utilities/local-date';
import { entityNameForLists } from '../../../utilities/text';
import type { ListItemIcon } from '../../../library/lists/listItemIcon';
import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';

export function toListItem(item: RiskAssessmentViewModel, hrefPrefix: string): ListSectionItemInput {
  let href = hrefPrefix + 'riskAssessments/' + item.uuid;
  if (!item.isConfirmedEntity || !item.name || item.unchangedTemplate) {
    href += '?edit';
  }
  let mainIcon: ListItemIcon;
  if (item.mainTemplateId !== undefined && item.unchangedTemplate) {
    mainIcon = 'suggestion';
  } else if (item.consequence && item.probability) {
    mainIcon = ('risk' + riskLevelFromRisk(item.consequence * item.probability)) as ListItemIcon;
  } else {
    mainIcon = 'risk0';
  }
  return {
    accessible: true,
    updateStatus: calculateUpdateStatus(item, LocalDate.now()),
    hasDraft: item.hasDraft,
    label: entityNameForLists(item.name, item.draftName, item.isConfirmedEntity),
    secondaryLabel: '',
    href,
    mainIcon,
  };
}
